import { FontConfig } from "../types"

export const BODY_2XL_CONFIG: FontConfig = {
  title: "BODY/2xl",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 18, tw: "text-[18px]" },
    lineHeight: { px: 26, tw: "leading-[26px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 20, tw: "text-[20px]" },
    lineHeight: { px: 28, tw: "leading-[28px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 28, tw: "text-[28px]" },
    lineHeight: { px: 27, tw: "leading-[27px]" },
  },
}
